import {
  PaymentMethodResponse,
  PaymentIntentResponse,
  PaymentMethodType,
  CarbonOffsetState,
  PaymentChargeRequest,
  SqaurePaymentRequest,
  SqaurePaymentParams
} from '@flyblack/common/domains';

import { authorizedApi } from '../network/authorized-api';

export const getPaymentMethods: () => Promise<PaymentMethodResponse> = () => authorizedApi.get(`/v1/payments/methods`);

export const createSquareCardPaymentMethod = ({ sourceId, verificationToken }: SqaurePaymentParams) =>
  authorizedApi.post<any>(`/v1/payments/methods`, {
    paymentMethodType: PaymentMethodType.Card,
    sourceId,
    verificationToken
  });

export const createPaymentIntent = ({
  productId,
  typeOfProduct,
  payCarbonOffset,
  seats,
  code,
  discountType
}: PaymentChargeRequest) =>
  authorizedApi.post<PaymentIntentResponse>(`/v1/payments/card`, {
    productId,
    paymentForType: typeOfProduct,
    carbonOffset: payCarbonOffset ? CarbonOffsetState.Included : CarbonOffsetState.NotIncluded,
    seats,
    code,
    discountType
  });

export const finalizeSquarePayment = ({ orderId, sourceId, verificationToken }: SqaurePaymentRequest) =>
  authorizedApi.post(`/v1/payments`, { orderId, sourceId, verificationToken });

export const getLinkToken: () => Promise<unknown> = () => authorizedApi.get(`/v1/payments/link-token`);

// Old ACH API
export const createACHPaymentMethod: (accountId: string, publicToken: string) => Promise<unknown> = (
  accountId,
  publicToken
) => authorizedApi.post(`/v1/payments/methods`, { paymentMethodType: PaymentMethodType.ACH, accountId, publicToken });

// New Sqaure ACH API to save payment method
export const createSquareACHPaymentMethod = (sourceId: string) =>
  authorizedApi.post<any>(`/v1/payments/methods`, {
    paymentMethodType: PaymentMethodType.ACH,
    sourceId
    // verificationToken
  });

export const payWithACH = ({
  bankAccountId,
  productId,
  typeOfProduct,
  payCarbonOffset,
  seats,
  code,
  discountType
}: PaymentChargeRequest) =>
  authorizedApi.post(`/v1/payments/ach`, {
    bankAccountId,
    productId,
    paymentForType: typeOfProduct,
    carbonOffset: payCarbonOffset ? CarbonOffsetState.Included : CarbonOffsetState.NotIncluded,
    seats,
    code,
    discountType
  });

export const deletePaymentMethod = (id: string, type: PaymentMethodType) =>
  authorizedApi.delete(`/v1/payments/methods`, { paymentMethodId: id, type });
